import { useState } from "react";
import axios from "axios";
import { API } from "../../App";

const HubEmailsPanel = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSend = async () => {
    if (!window.confirm("Send Delegate Hub links to all completed registrations that haven't received it yet?")) return;
    setLoading(true);
    setResult(null);
    try {
      const token = localStorage.getItem("adminToken");
      const res = await axios.post(`${API}/registrations/admin/send-hub-emails`, {}, {
        headers: { Authorization: `Bearer ${token}`, "X-Frontend-Origin": window.location.origin }
      });
      setResult(res.data);
    } catch (err) {
      setResult({ message: err.response?.data?.detail || "Failed to send emails" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-800/60 rounded-xl border border-slate-700 p-6" data-testid="hub-emails-panel">
      <h2 className="text-lg font-semibold text-white mb-2">Delegate Hub Emails</h2>
      <p className="text-slate-400 text-sm mb-4">Sends each completed registration their personal Delegate Hub link (badge + QR + programme). Safe to click repeatedly — already-sent delegates are skipped.</p>
      <button
        onClick={handleSend}
        disabled={loading}
        className="bg-sky-600 hover:bg-sky-700 text-white font-medium px-4 py-2 rounded-lg text-sm disabled:opacity-50"
        data-testid="send-hub-emails-btn"
      >
        {loading ? "Sending..." : "Send Delegate Hub links to all pending"}
      </button>
      {result && (
        <div className="mt-4 bg-slate-700/50 rounded-lg p-4 text-sm text-slate-200" data-testid="hub-emails-result">
          <p>{result.message}</p>
          {result.eligible !== undefined && (
            <p className="text-slate-400 mt-1">Eligible: {result.eligible} · Sent: {result.sent} · Failed: {result.failed}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default HubEmailsPanel;
